import {
  REQUEST_INQUIRY_LIST
} from './mutation-types';
  
import axiosInst from '@/utility/axiosInst';
  
export default {
  requestCreateInquiry({}, payload) {
    return axiosInst.springAxiosInst.post("/inquiry/create-inquiry", payload)
    .then((res) => {
      return res.data
    }).catch((err) => {
      console.error(err)
    })
  },

  requestInquiryList({commit}, payload) {
    const {currentPage, startDate, endDate} = payload
    return axiosInst.springAxiosInst.get("/inquiry/get-list", {
      params: {
        page: currentPage,
        startDate: startDate,
        endDate : endDate
      }
    }).then((res) => {
      commit(REQUEST_INQUIRY_LIST, res.data)
    })
  },

  requestDeleteInquiries({}, payload) {
    return axiosInst.springAxiosInst.post('/inquiry/delete-inquiries', payload)
    .then((res) => {
      return res.data
    })
  }
}